import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormSwitchery from 'components/forms/FormSwitchery';
import DatePicker from 'components/forms/DatePicker';

import { getTimezoneFromState } from 'helpers/intl';

class WhiteLabelPluginEditData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['plugins', props.dataIndex];
  }

  getTimezone = () => {
    const { defaultTimezone, timezone } = this.props;
    return timezone || defaultTimezone;
  };

  componentDidUpdate = prevProps => {
    const { dataIndex } = this.props;

    if (prevProps.dataIndex !== dataIndex) {
      this.defaultFieldTree = ['plugins', dataIndex];
    }
  };

  render() {
    const {
      intl: { messages },
      disabled,
      data,
      colSpan,
      appIntl,
    } = this.props;

    return (
      <tr class="row-details">
        <td colSpan={colSpan}>
          <Row>
            <Col xs={12} md={5}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <div class="form-group-attached">
                    <FormSwitchery
                      name="isActive"
                      checked={data.getIsActive()}
                      value
                      label={messages.is_active}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </Col>
            {!data.isActive && !data.terminatedBy ? (
              <Col xs={12} md={5}>
                <div class="form-group-attached">
                  <DatePicker
                    name="freeUntil"
                    label={messages.test_period_until}
                    value={data.freeUntil}
                    locale={appIntl.locale}
                    displayTz={this.getTimezone()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                    style={{ borderRight: 0, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                    appendToBody
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    defaultTimezone: getTimezoneFromState(state),
  };
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelPluginEditData));
